<template>
  <div class="container">
    <div class="space"></div>
    <img
      class="title"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/823f584811d830b88b088e529422733d.png"
    />
    <div class="scan-content">
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_banner"
        class="scan-image"
        alt=""
      />
      <div class="scan-linear">
        <div class="linear"></div>
        <div class="change"></div>
      </div>
      <div class="scan-animate">
        <div class="circle circle-1"></div>
        <div class="circle circle-2"></div>
        <div class="circle circle-3"></div>
        <div class="circle circle-4"></div>
      </div>
      <div class="scan-float">
        <img
          class="text text-1"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_text_1"
          alt=""
        />
        <img
          class="text text-2"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_text_2"
          alt=""
        />
        <img
          class="text text-3"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_text_3"
          alt=""
        />
        <img
          class="ball ball-1"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_ball_1"
          alt=""
        />
        <img
          class="ball ball-2"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_ball_2"
          alt=""
        />
        <img
          class="ball ball-3"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_ball_3"
          alt=""
        />
      </div>
    </div>
    <div class="click">
      <div class="click-btn" @click="bindClick" v-show="this.userData">
        <span>开始拍照解析</span>
        <input
          v-if="!isApp"
          class="image-input"
          type="file"
          ref="files"
          capture="camera"
          accept="image/*"
          @change="bindPicChange"
          name=""
          id=""
        />
      </div>
    </div>
    <div class="tips">为了解读结果更准确，请确保配料图片拍摄清晰、完整</div>
    <img
      class="logo"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
    />
    <MyToast
      v-show="showToast"
      :title="toastTitle"
      :desc="toastDesc"
      :confirmText="toastConfirmText"
      :image="toastImage"
      @confirm="bindConfirm"
      @cancel="bindCancel"
    ></MyToast>
  </div>
</template>
<script>
import MyToast from '@/components/app/toast/confirm-toast.vue'
export default {
  components: { MyToast },
  data() {
    return {
      isApp: false,
      userData: null,
      toastImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_err_icon_1',
      toastTitle: '',
      toastDesc: '',
      toastConfirmText: '',
      showToast: false
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.getData()
  },
  mounted() {
    //埋点 配料表首页曝光
    this.$buryPoint('BG_PLJD', {})
  },
  methods: {
    bindConfirm() {},
    bindCancel() {
      this.showToast = false
    },

    bindClick() {
      if (!this.userData) {
        return
      }
      if (!this.userData.uid) {
        //未登录
        this.$betterwe.isLogin(() => {
          this.getData(true)
        })
      } else if (this.userData.uid && this.userData.num <= 0) {
        //没有次数了
        if (this.userData.is_pay) {
          this.bindShowUseEnd()
        } else {
          this.bindShowBuy()
        }
        this.showToast = true
      } else if (this.userData.uid && this.userData.num > 0) {
        this.selectPic()
      }
    },
    //次数用完提示
    bindShowUseEnd() {
      this.toastTitle = '温馨提示'
      this.toastDesc = '您今日解析次数已用完'
      this.toastConfirmText = '好的'
      this.showToast = true
      this.bindConfirm = () => {
        this.showToast = false
      }
    },
    //次数用完显示购买大会员
    bindShowBuy() {
      this.toastTitle = '温馨提示'
      this.toastDesc = `<div style='font-size: 14px;color: rgba(0,0,0,0.6);line-height: 24px;margin-bottom:8px'>您今日解析次数已用完, 请明日再来</div>
          <div style='font-size: 14px;font-weight: 600;color: rgba(0,0,0,0.8);line-height: 20px;'>升级 <span style="position:relative;z-index:1">WE+减脂会员<span
            style='position:absolute;left:0;bottom:2px;width: 100%;height: 6px;background: #FFDDBE;border-radius: 3px;z-index:-1' ></span></span><br/>畅享无限次抽取</div>`
      this.toastConfirmText = '查看WE+减脂会员权益'
      this.showToast = true
      this.bindConfirm = async () => {
        this.showToast = false
        let version = await this.$betterwe.getAppVersion()
        if (version >= 98) {
          this.$betterwe.vipHomePage()
        } else {
          this.$router.push('/betterwe/vip')
        }
      }
    },
    async selectPic() {
      if (this.isApp) {
        let res = await this.$betterwe.onAppCamera().catch(() => {})
        if (res) {
          res = JSON.parse(res)
          if (!Array.isArray(res)) {
            this.$toast('获取图片失败')
          }
          this.$store.commit(
            'ingredient/setImageSource',
            'data:image/png;base64,' + res[0]
          )
          this.$router.push('/ingredient/preview')
        }
      } else {
        this.$toast('请在app内打开')
      }
      //埋点 配料表去使用
      this.$buryPoint('APP_INGREDIENT_USE', {})
    },
    bindPicChange(e) {
      let file = e.target.files[0] //图片文件名
      if (!e || !window.FileReader) {
        // 看是否支持FileReader
        this.$toast('图片暂不支持查看')
        return
      }
      this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载图片中...'
      })
      let reader = new FileReader()
      reader.readAsDataURL(file) // 关键一步，在这里转换的
      reader.onload = (e) => {
        this.$toast.clear()
        this.$store.commit('ingredient/setImageSource', e.target.result)
        this.$router.push('/ingredient/preview')
      }
    },
    getData(isClick) {
      let params = {}
      this.$http
        .getApp('tool/Ingredient/judgeUserAvailableNum', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.userData = res.data
            if (isClick) {
              this.bindClick()
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ingredients_list_home_bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  box-sizing: border-box;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    object-fit: contain;
    height: 10.59vh;
  }

  .space {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .scan-content {
    position: relative;
    z-index: 0;
    margin-top: 4.67vh;
    margin-bottom: 4.92vh;
    height: 48.76vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .scan-image {
      height: 100%;
      object-fit: contain;
    }

    .scan-linear {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      .linear {
        width: 100%;
        height: 10%;
        overflow: hidden;
        border-top: 3px solid rgba(83, 35, 254, 0.2);
        background: linear-gradient(
          180deg,
          rgba(83, 35, 254, 0.2) 0%,
          rgba(83, 35, 254, 0.1) 20%,
          rgba(255, 255, 255, 0) 100%
        );
      }

      .change {
        width: 100%;
        height: 0%;
        animation: myAnimateUp 3s linear infinite;
      }
    }

    .scan-animate {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      animation: myScare 3s linear infinite;

      .circle {
        position: absolute;
        width: 25px;
        height: 25px;
        opacity: 0.8;
      }

      .circle-1 {
        left: 14px;
        top: 14px;
        border-top: 3px solid #6a4ded;
        border-left: 3px solid #6a4ded;
        border-top-left-radius: 6px;
      }

      .circle-2 {
        right: 14px;
        top: 14px;
        border-right: 3px solid #6a4ded;
        border-top: 3px solid #6a4ded;
        border-top-right-radius: 6px;
      }

      .circle-3 {
        left: 14px;
        bottom: 14px;
        border-left: 3px solid #6a4ded;
        border-bottom: 3px solid #6a4ded;
        border-bottom-left-radius: 6px;
      }

      .circle-4 {
        right: 14px;
        bottom: 14px;
        border-right: 3px solid #6a4ded;
        border-bottom: 3px solid #6a4ded;
        border-bottom-right-radius: 6px;
      }

      .scan-linear {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100px;
      }
    }

    .scan-float {
      .text,
      .ball {
        object-fit: contain;
        position: absolute;
        z-index: 10;
      }

      .text-1 {
        width: 153px;
        left: -9.52%;
        top: 10.86%;
      }

      .text-2 {
        width: 117px;
        right: -9.52%;
        top: 50%;
        transform: translate(0%, -50%);
      }

      .text-3 {
        width: 215px;
        left: -9.52%;
        bottom: 10.6%;
      }

      .ball-1 {
        width: 54px;
        left: 9.52%;
        top: 29.3%;
      }

      .ball-2 {
        width: 54px;
        right: 13.18%;
        top: 10%;
      }

      .ball-3 {
        width: 54px;
        right: -4%;
        bottom: 18.68%;
      }
    }
  }

  .click {
    text-align: center;
    margin-bottom: 1.2vh;
    width: 273px;
    height: 42px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #6236ff;
    line-height: 42px;
    letter-spacing: 1px;

    .click-btn {
      height: 100%;
      box-sizing: border-box;
      border-radius: 21px;
      position: relative;
      border: 2px solid #6236ff;
    }

    .test {
      position: absolute;
      top: -15px;
      left: 192px;
      height: 30px;
      background: #7b5bc7;
      box-shadow: 0px 4px 6px 0px rgba(98, 54, 255, 0.15);
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      border-radius: 15px 15px 15px 0px;
      padding: 0px 12px;
      box-sizing: border-box;
      line-height: 30px;
    }

    .image-input {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }

  .tips {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    line-height: 14px;
    margin-bottom: 2.7vh;
  }

  .logo {
    height: 16px;
    margin-bottom: 46px;
  }
}

@keyframes myScare {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes myAnimateUp {
  0% {
    height: 0%;
  }

  100% {
    height: 70%;
  }
}
</style>
